module.exports = __webpack_public_path__ + "img/button-ok.ec18db07.svg";